import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSnowFlake = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 .667c.262 0 .473.214.473.48v1.742l1.482-1.203a.47.47 0 0 1 .665.075.485.485 0 0 1-.074.674L8.473 4.118v1.32l1.476.866 1.127-.66.4-2.665a.474.474 0 0 1 .538-.402c.258.04.436.285.396.547l-.286 1.905 1.488-.872a.47.47 0 0 1 .646.176c.13.23.053.523-.173.655l-1.488.872 1.769.702a.48.48 0 0 1 .268.621.47.47 0 0 1-.612.273l-2.473-.981-1.127.66v1.73l1.127.66 2.473-.981a.47.47 0 0 1 .612.272.48.48 0 0 1-.268.622l-1.769.701 1.488.872a.484.484 0 0 1 .173.656.47.47 0 0 1-.646.175l-1.488-.872.286 1.906a.48.48 0 0 1-.396.547.474.474 0 0 1-.538-.402l-.4-2.665-1.127-.66-1.476.865v1.321l2.073 1.683a.485.485 0 0 1 .074.675.47.47 0 0 1-.665.075L8.473 13.11v1.742c0 .265-.211.48-.473.48a.476.476 0 0 1-.472-.48V13.11l-1.484 1.205a.47.47 0 0 1-.664-.075.485.485 0 0 1 .073-.675l2.075-1.684v-1.319L6.05 9.697l-1.126.66-.4 2.664a.474.474 0 0 1-.538.402.48.48 0 0 1-.396-.547l.286-1.905-1.487.871a.47.47 0 0 1-.646-.176.484.484 0 0 1 .173-.655l1.488-.871-1.77-.702a.48.48 0 0 1-.268-.622.47.47 0 0 1 .612-.272l2.474.981 1.125-.659V7.134l-1.125-.66-2.474.982a.47.47 0 0 1-.612-.273.48.48 0 0 1 .268-.621l1.77-.702-1.488-.872a.484.484 0 0 1-.173-.655c.13-.23.42-.308.646-.176l1.487.872-.286-1.905a.48.48 0 0 1 .396-.547c.258-.04.5.14.538.402l.4 2.664 1.126.66 1.478-.865V4.119L5.453 2.435a.485.485 0 0 1-.073-.675.47.47 0 0 1 .664-.074L7.528 2.89V1.146c0-.265.211-.48.472-.48M6.522 8.865v-1.73L8 6.268l1.477.865v1.731L8 9.73z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSnowFlake;
